import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {debounceTime, distinctUntilChanged, fromEvent, map, Subscription, tap} from "rxjs";

require('./bringoz-expandable-search-input.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-expandable-search-input',
  templateUrl: './bringoz-expandable-search-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozExpandableSearchInputComponent implements AfterViewInit, OnDestroy {

  @Input() query: string;
  @Input() isDisabled: boolean;
  @Input() placeholder: string;
  @Input() minLength: number;
  @Output() queryChangeEvent = new EventEmitter<string>();

  @ViewChild('search', {static: true}) search: ElementRef;
  @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
  private inputSubscription: Subscription;

  public isExpanded: boolean = false;

  constructor() {
  }

  ngAfterViewInit() {
    this.searchInput.nativeElement.value = this.query || '';
    this.inputSubscription = fromEvent(this.searchInput.nativeElement, 'input').pipe(
      map((event: Event) => (event.target as HTMLInputElement).value),
      debounceTime(1000),
      distinctUntilChanged(),
      tap(value => this.queryChangeEvent.emit(value))
    ).subscribe();
  }

  onToggleExpand(value: boolean, event) {
    event.stopPropagation();
    this.isExpanded = value;

    if (this.isExpanded) {
      this.search.nativeElement.classList.add('expanded');
    } else {
      this.search.nativeElement.classList.remove('expanded');
    }
  }

  ngOnDestroy() {
    this.inputSubscription.unsubscribe();
  }

}
